import { render } from "./StockAdjustments.vue?vue&type=template&id=6fe07a4d&scoped=true"
import script from "./StockAdjustments.vue?vue&type=script&lang=js"
export * from "./StockAdjustments.vue?vue&type=script&lang=js"

import "./StockAdjustments.vue?vue&type=style&index=0&id=6fe07a4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe07a4d"]])

export default __exports__